import { useToast } from "@/hooks/use-toast";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from "@/components/ui/toast";
import { CheckCircle2, AlertTriangle, Info } from "lucide-react";

const ICONS = {
  success: <CheckCircle2 size={18} className="text-accent flex-shrink-0 mt-0.5" />,
  destructive: <AlertTriangle size={18} className="text-destructive-foreground flex-shrink-0 mt-0.5" />,
  default: <Info size={18} className="text-primary flex-shrink-0 mt-0.5" />,
} as const;

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const icon = ICONS[(variant as keyof typeof ICONS) ?? "default"] ?? ICONS.default;
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3">
              {icon}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && <ToastDescription>{description}</ToastDescription>}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
